import Swal from 'sweetalert2';
import { ROUTES } from 'app/core/router/paths';
import { ModalNamesEnum } from 'app/core/enums/ui/modals';
import store from 'app/store';
import { setModalVisibleAction } from 'app/store/ui/actions';
import { setLoginRedirectURLAction } from 'app/store/features/member/login/actions';

/**
 * @description 基本 Modal
 * @param title 標題
 * @param content 內容
 * @param confirmButtonText 「確認按鈕」文字
 */
const base = (title: string, content: string, confirmButtonText: string = '確認') => {
  return Swal.fire({
    title: title,
    html: content,
    confirmButtonText: confirmButtonText,
    showCloseButton: true,
    closeButtonHtml: ''
  });
};

/**
 * @description 確認 Modal
 * @param title 標題
 * @param content HTML 內容
 * @param confirmButtonText 「確認按鈕」文字
 * @param cancelButtonText 「取消按鈕」文字
 */
const confirm = (title: string, content: string, confirmButtonText: string = '確認', cancelButtonText: string = '取消') => {
  return Swal.fire({
    title: title,
    html: content,
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    showCancelButton: true,
    showCloseButton: true,
    closeButtonHtml: ''
  });
};

const swalClose = () => {
  Swal.close();
};

/**
 * @description 設置 Modal 能見度
 * @param name Modal Name
 * @param visible Modal 能見度
 */
const trigger = (name: ModalNamesEnum, visible: boolean) => {
  store.dispatch(setModalVisibleAction(name, visible));
};

/**
 * @description 設置 Login Modal 能見度
 * @param visible Dialog 能見度
 * @param redirectURL 登入後的轉導路由
 * @param state 透過路由傳遞的 State
 */
const login = (visible: boolean, redirectURL?: ROUTES, state?: any) => {
  store.dispatch(setModalVisibleAction(ModalNamesEnum.MemberLoginModal, visible));
  if (redirectURL) store.dispatch(setLoginRedirectURLAction(redirectURL, state));
};

/**
 * @description 設置網服 Register Modal 能見度
 * @param visible Dialog 能見度
 */
const registerNS = (visible: boolean) => {
  store.dispatch(setModalVisibleAction(ModalNamesEnum.MemberRegisterNSModal, visible));
};

export default {
  base,
  confirm,
  trigger,
  login,
  registerNS,
  swalClose
};
